var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"radimix-pealeht",staticStyle:{"height":"100%"}},[_c('PealehtHeading'),_c('Info')],1):_c('div',[_vm._v("Laadimine...")])}
var staticRenderFns = []

export { render, staticRenderFns }